module.exports = __webpack_public_path__ + "img/QuickEntrance_gzdy.20e143a4.svg";